import React, { FC } from 'react';
import CMPImage from 'components/global/image';
interface Props {
  wh?: number;
}
const GemCuttingIcon: FC<Props> = ({ wh }) => {
  return (
    <CMPImage
      asset={{
        src: `${process.env.PUBLIC_URL}/images/professions/Gem_Cutting.png`,
        alt: 'Gem Cutting',
      }}
      width={wh || 64}
      height={wh || 64}
    />
  );
};

export default GemCuttingIcon;
